export default [
	'bedc:dashboard:read/jobs',
	'bedc:dashboard:read/projects',
	'bedc:dashboard:read/transactions',
] as const;
